export function scrollSmoothly(e: React.MouseEvent<HTMLAnchorElement>) {
  const target = e.currentTarget.getAttribute("href")
  if (target?.startsWith("#")) {
    const element = document.querySelector(target)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
      e.preventDefault()
    }
  }
}
